import * as yup from "yup";

export const FormSchema = yup.object({
  firstName: yup.string().required("First Name is required."),
  lastName: yup.string().required(" Last Name is required."),
  email: yup
    .string()
    .email("Please enter a valid email address.")
    .required("Email field is required."),
  phoneNumber: yup.string().required("Phone Number is Required"), 
  message: yup
    .string()
    .optional("Message is optional.")
    .max(1000, "Max 1000 characters allowed."),
});
